import { element, IDirective, IDocumentService } from 'angular';
import './ng.multi.select.sass';
import map from 'lodash-es/map';
import remove from 'lodash-es/remove';
import find from 'lodash-es/find';
import findIndex from 'lodash-es/findIndex';
import has from 'lodash-es/has';
import { checkToKeepping } from '../../../helpers/check-to-keeping';

export function ngMultiSelectDirective( $document: IDocumentService ): IDirective {
  return {
    restrict: 'E',
    replace: true,
    template: require('./ng.multi.select.pug')(),
    scope: {
      optionsArray: '=',
      selectedOptions: '=',
      isGroup: '='
    },
    link: function postLink( scope: any, tElement, attrs ) {
      scope.selectShowFlag = false;
      scope.optionsArrayTemp = [];
      const scopeExpression = attrs.outsideClick;
      const onDocumentClick = ( event ) => {
        event.preventDefault();
        if ( checkToKeepping(element, event.toElement) ) {
          return;
        } else {
          scope.selectShowFlag = false;
          $document.off('click', onDocumentClick);
          scope.$apply(scopeExpression);
        }
      };
      const buttonClick = ( $event ) => {
        $event.preventDefault();
        scope.$apply(() => {
          scope.selectShowFlag = !scope.selectShowFlag;
          if ( scope.selectShowFlag ) {
            $document.on('click', onDocumentClick);
          } else {
            $document.off('click', onDocumentClick);
          }
        });
      };
      const getGroupId = ( elem ): number | string => {
        let id = null;
        map(scope.optionsArray, ( e ) => {
          const temp = find(e[ 'options' ], (j) => {
            if ( j[ 'id' ] === elem.id ) {
              id = j[ 'groupId' ];
              return true;
            }
          });
        });
        return id;
      };

      scope.deleteItemByName = ( options: any[], callback: ( item, index ) => any ): any[] => {
        const names = scope.selectedOptions;
        for ( let j = 0; j < names.length; j++ ) {
          remove(options, ( elem ) => {
            if ( names[ j ].id === elem.id ) {
              callback(elem, j);
              return true;
            }
          });
        }
        return options;
      };

      const optionsInitialize = () => {
        if ( !scope.selectedOptions ) {
          scope.selectedOptions = [];
        }
        if ( !scope.optionsArray || scope.optionsArray.length === 0 ) {
          return;
        }
        scope.optionsArrayTemp = JSON.parse(JSON.stringify(scope.optionsArray));

        if ( scope.isGroup && scope.optionsArrayTemp.length ) {
          for ( let i = 0; i < scope.optionsArrayTemp.length; i++ ) {
            scope.optionsArrayTemp[ i ].options = scope.deleteItemByName(
              scope.optionsArrayTemp[ i ].options,
              ( option, index ) => {
                scope.selectedOptions[ index ][ 'groupId' ] = option.groupId;
              });
          }
        } else {
          scope.optionsArrayTemp = scope.deleteItemByName(scope.optionsArrayTemp, ( x, y ) => x);
        }
      };

      scope.skipItem = ( index: number ) => {
        manipulateElements(scope.selectedOptions[ index ]);
        remove(scope.selectedOptions, ( elem, i ) => i === index);
      };

      scope.addItemToResult = ( item: any ) => {
        scope.selectedOptions.push(item);
        manipulateElements(item);
      };

      const manipulateElements = ( elem: any ) => {
        const gId = has(elem, 'groupId') ? elem.groupId : getGroupId(element);
        const index: number = scope.isGroup ? findIndex(scope.optionsArrayTemp[ gId ].options, ( e ) => e[ 'id' ] === elem.id) : scope.optionsArrayTemp.indexOf(element);
        if ( index > -1 ) {
          if ( scope.isGroup ) {
            remove(scope.optionsArrayTemp[ gId ].options, ( e, i ) => index === i);
          } else {
            remove(scope.optionsArrayTemp, ( e, i ) => index === i);
          }
        } else {
          if ( scope.isGroup ) {
            scope.optionsArrayTemp[ gId ].options.push(element);
          } else {
            scope.optionsArrayTemp.push(element);
          }
        }
      };
      element(tElement[ 0 ].querySelector('.selected-element-dropdown')).on('click', buttonClick);
      scope.$watch('selectedOptions', () => {
        optionsInitialize();
      });
      scope.$watch('optionsArray', () => {
        optionsInitialize();
      });
    }
  };
}

ngMultiSelectDirective.$inject = [ '$document' ];



// WEBPACK FOOTER //
// ./app/shared/directives/ng.multi.select/ng.multi.select.directive.ts